// import { createStore, applyMiddleware, Middleware } from 'redux';
// import { persistStore } from 'redux-persist';
// import thunk, { ThunkMiddleware } from 'redux-thunk';
// import logger from 'redux-logger';

// import rootReducer from './reducers/rootReducer';

// const middlewares: (ThunkMiddleware | Middleware)[] = [thunk];

// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger);
// }

// const store = createStore(rootReducer, applyMiddleware(...middlewares));

// export const persistor = persistStore(store);

// export default store;

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
// import rootReducer from './reducers/rootReducer';
import userReducer from './reducers/userReducer/userReducer';
import notificationsReducer from './reducers/notifications/notificationsReducer';

// Configure persist options
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'notifyList']
};

const rootReducer = combineReducers({
  user: userReducer,
  notification: notificationsReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types to prevent serializable check warnings with redux-persist
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

export const persistor = persistStore(store);

// Export types for TypeScript support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
